import PropTypes from 'prop-types';
import React from 'react';
import { useLabels } from 'wsm-common-data';
import { setClassNames } from '@ddc/classnames-js';

const CarouselButton = ({ direction, clickEvent, mouseUpEvent, classes }) => {
	const labels = useLabels();
	const text =
		direction === 'right'
			? labels.get('NEXT_PHOTO')
			: labels.get('PREVIOUS_PHOTO');

	return (
		<button
			className={setClassNames([
				'btn-carousel',
				'btn-carousel-sm',
				'd-none',
				...classes
			])}
			onClick={clickEvent}
			onMouseUp={mouseUpEvent}
			title={text}
			type="button"
		>
			<span className="btn-carousel-inner">
				<i
					role="presentation"
					aria-hidden="true"
					className={setClassNames([
						'ddc-icon',
						'ddc-icon-carousel-arrow',
						`ddc-icon-carousel-arrow-${direction}`,
						'd-block'
					])}
				/>
			</span>
			<span className="sr-only">{text}</span>
		</button>
	);
};

CarouselButton.propTypes = {
	direction: PropTypes.string.isRequired,
	clickEvent: PropTypes.func.isRequired,
	mouseUpEvent: PropTypes.func,
	classes: PropTypes.arrayOf(PropTypes.string)
};

CarouselButton.defaultProps = {
	mouseUpEvent: () => null,
	classes: []
};

export default CarouselButton;
